import React from 'react';
import { Box, Typography } from '@mui/material';

interface SectionCardProps {
  title: string;
  children: React.ReactNode;
  titleColor?: string;
}

const SectionCard: React.FC<SectionCardProps> = ({ title, children, titleColor }) => (
  <Box sx={{ position: 'relative', height: '100%' }}>
    {/* Dynamic Section Title */}
    <Typography
      sx={{
        position: 'absolute',
        top: 0,
        left: 24,
        transform: 'translateY(-50%)',
        backgroundColor: 'white',
        color: `${titleColor || '#1A55F9'}`,
        px: 1,
        fontWeight: '600',
        fontSize: '18px',
      }}
    >
      {title}
    </Typography>

    {/* Inner Content Box */}
    <Box
      sx={{
        border: '1px solid #ccc',
        borderRadius: 2,
        p: 2,
        backgroundColor: 'white',
        textAlignLast: 'center',
      }}
    >
      {children}
    </Box>
  </Box>
);

export default SectionCard;
